module.exports = __webpack_public_path__ + "img/downPriceArrow.e15c1e95.svg";